export default class ApiService {

	static get $inject(){
		return [
			'$q', '$http', '$cookies',
			'ApiService'
		];
	}

	constructor($q, $http, $cookies,
	            ApiService){

		this.api = ApiService.api;
		this.errors = ApiService.errors;
		this.successes = ApiService.successes;

		this.$q = $q;
		this.$http = $http;
		this.$cookies = $cookies;

	}

	get service(){
		return {

			getPanels: {
				name: 'panels',
				humanName: 'Panels list',
				description: 'Panels list associated with current logged-in account. Returns Array of user panel Objects',
				request: {
					type: 'GET',
					route: '/personal/panels'
				},
				response: {
					success: {
						data: [
							{ name: 'Array (JSON)', type: 'Array', description: 'Panels array' }
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: ()=>
					this.$http({
						url: this.api + '/personal/panels',
						method: 'GET',
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			updatePanel: {
				name: 'updatePanel',
				humanName: 'Update Panel Data',
				description: 'Update Panel or PanelUser data in Database.',

				request: {
					type: 'PUT',
					route: '/personal/panels/:panelId',
					params: [
						{ name: 'panelId', type: 'Integer', description: 'Panel id' }
					],
					param: [],
					data: [
						{
							name: 'userCode',
							type: 'Int',
							description: 'Update UserCode (will NOT be checked at Control Panel)'
						},
						{
							name: 'remoteAccessPassword',
							type: 'Int',
							description: 'Update RemoteAccessPassword (will NOT be checked at Control Panel)'
						},
						{ name: 'notificationFilter', type: 'Int', description: 'Update Permissions Bitmask' },
						{ name: 'name', type: 'String', description: 'Panel name (for current user)' },
						{
							name: 'location',
							type: 'String',
							description: 'Panel location latitude and longitude in form of String: "POINT (10.0000 10.0000)"'
						}
					],
					example: angular.toJson({
						userCode: 1234,
						remoteAccessPassword: 12345678,
						notificationFilter: 124,
						name: 'New Name',
						location: 'POINT (10.0000 10.0000)'
					})
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/panels/' + param,
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			removePanelFromAccount: {
				name: 'removeFromAccount',
				humanName: 'Remove Panel from Account',
				description: 'Removes panel from account, do not require remote access connection',
				request: {
					type: 'DELETE',
					route: '/personal/panels/remove/:mac',
					params: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' }
					],
					param: ['0013A1022C7B']
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data,param)=>
					this.$http({
						url: this.api + '/personal/panels/remove/' + param,
						method: 'DELETE',
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			}/*,

			panelUsersList: {
				name: 'panelUsersList',
				humanName: 'Get Panel Users List',
				description: 'Removes panel from account, do not require remote access connection',
				request: {
					type: 'DELETE',
					route: '/personal/panels/remove/:mac',
					params: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' }
					],
					param: ['0013A1022C7B']
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data,param)=>
					this.$http({
						url: this.api + '/personal/panels/remove/' + param,
						method: 'DELETE',
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			}*/
		}
	}

}



/** WEBPACK FOOTER **
 ** ./src/main/apiTest/services/api.service.personal.panels.js
 **/